import React from "react";
import Template from "../components/auth/Template";

function Signup() {
  return <Template text="Welcome to Memory Match" formType="signup" />;
}

export default Signup;
